import { ROLE, normalizeRoles, canonRole } from "../constants/UserConstant";
import { get } from "lodash";
export default class User {
  constructor(data = {}) {
    Object.assign(this, data);
    this.roles = normalizeRoles(data);
  }

  static fromApi(payload = {}) {
    const src = payload?.data && !payload.id ? payload.data : payload;
    return new User(src);
  }

  get fullName() {
    return [this.firstName, this.lastName].filter(Boolean).join(" ");
  }

  hasRole(role) {
    const r = canonRole(role);
    return Array.isArray(this.roles) && this.roles.includes(r);
  }

  get isSysAdmin() {
    return this.hasRole(ROLE.SYS_ADMIN);
  }

  get isDeveloper() {
    return this.hasRole(ROLE.DEVELOPER);
  }

  get isQaMode() {
		return this.hasRole(ROLE.QA);
	}

  get isSeanOrCustomer() {
    if (this?.id === "user-gdpki5cmym5m986vsg2v8aow") return true;
    if (this.isSysAdmin || this.isQaMode) return false;
    return true;
  }

  get userAlerts() {
    if(this?.alerts)
      return this.alerts
    return []
  }

  showUser() {
    return Array.isArray(this.userPlans) && this.userPlans.length > 0;
  }

  showEmployer() {
    return Boolean(get(this, "employerAdminEmployer.id"));
  }

  showPartner() {
    return this.isSysAdmin || Boolean(this.partnerId);
  }

  showReferrals() {
    return this.isSysAdmin || (!this.showPartner() && Boolean(this.isReferralAccount));
  }

  showUsers() {
    return this.isSysAdmin;
  }

  showEmployers() {
    return (this.isSysAdmin || (!this.showPartner() &&this.isMultiEmployerAdmin));
  }

  showOps() {
    return this.isSysAdmin;
  }

  showUsage() {
    return this.isSysAdmin;
  }

  showData() {
    return this.isDeveloper;
  }

  showSystem() {
    return this.isDeveloper;
  }

}